export default "__VITE_ASSET__CNJJBFHG__"